import { Signal } from '@angular/core';
import { providePageContext } from '@tourfold/shared-kernels/page-context';
import { CustomDomain } from '@tourfold/libraries/tf-api-client-frontend-v2';

export function provideCustomDomainsAiPageContext(domains: Signal<CustomDomain[]>): void {
  providePageContext(() => ({
    visible_rows: domains().slice(0, 25).map((d) => ({
      type: 'custom_domain',
      id: d.id,
      label: d.domain,
    })),
  }));
}
